/**
 * Persist cart / wishlist per logged-in web user. Guest uses a dedicated key.
 * Legacy keys `cart_products` / `wishlist_products` are migrated once into the active scope.
 */

export const LEGACY_CART_KEY = 'cart_products'
export const LEGACY_WISHLIST_KEY = 'wishlist_products'

export function getShopUserId() {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return null
    const u = JSON.parse(raw)
    const id = u?.id
    if (id == null || id === '') return null
    return String(id)
  } catch {
    return null
  }
}

export function cartStorageKeyForScope(userId = getShopUserId()) {
  return userId ? `cart_products__user_${userId}` : 'cart_products__guest'
}

export function wishlistStorageKeyForScope(userId = getShopUserId()) {
  return userId ? `wishlist_products__user_${userId}` : 'wishlist_products__guest'
}

export function migrateLegacyCartIntoKey(targetKey) {
  try {
    const legacy = localStorage.getItem(LEGACY_CART_KEY)
    if (legacy == null || legacy === '') return
    if (localStorage.getItem(targetKey) === null) {
      localStorage.setItem(targetKey, legacy)
    }
    localStorage.removeItem(LEGACY_CART_KEY)
  } catch {
    /* ignore */
  }
}

export function migrateLegacyWishlistIntoKey(targetKey) {
  try {
    const legacy = localStorage.getItem(LEGACY_WISHLIST_KEY)
    if (legacy == null || legacy === '') return
    if (localStorage.getItem(targetKey) === null) {
      localStorage.setItem(targetKey, legacy)
    }
    localStorage.removeItem(LEGACY_WISHLIST_KEY)
  } catch {
    /* ignore */
  }
}
